import {Box, Flex, Text} from '@chakra-ui/react'
import {useTranslation} from 'react-i18next'
import PropTypes from 'prop-types'

import {GiftBoxIcon} from '../../icons'
import {formatNumber} from '../../../utils/formatter'

const getConversionText = ([first, second], t) => {
  if (second === undefined || first.amount !== second.amount) {
    return t('payments:RewardPromo.singleRedemption', {
      amount: formatNumber(first.amount),
      partnerKey: first.key,
    })
  }

  return t('payments:RewardPromo.multipleRedemption', {
    amount: formatNumber(first.amount),
    partnerOneKey: first.key,
    partnerTwoKey: second.key,
  })
}

export const RewardPromo = ({coins, redemptionOptions}) => {
  const {t} = useTranslation('payments')

  if (coins === 0) {
    return null
  }

  return (
    <Box py="sm">
      <Box
        p="sm"
        border="1px solid"
        borderColor="mld.neutral.500"
        borderRadius="md"
      >
        <Flex justify="space-between" align="center" flexWrap="wrap" gap="xs">
          <Flex align="center" gap="sm">
            <GiftBoxIcon boxSize="24px" />
            <Box>
              <Text textStyle="body-copy">
                {t('payments:RewardPromo.title')}
              </Text>
              {redemptionOptions.length > 0 && (
                <Text textStyle="body-detail" color="mld.neutral.700">
                  {getConversionText(redemptionOptions, t)}
                </Text>
              )}
            </Box>
          </Flex>
          <Text textStyle="body-copy-medium" whiteSpace="nowrap">
            {t('payments:RewardPromo.coins', {coins: formatNumber(coins)})}
          </Text>
        </Flex>
      </Box>
    </Box>
  )
}

RewardPromo.propTypes = {
  coins: PropTypes.number,
  redemptionOptions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
    }),
  ),
}

RewardPromo.defaultProps = {
  coins: 0,
  redemptionOptions: [],
}
